/** Card elevation tokens — see .cursor/rules/react-architecture.mdc §6.8.1 */

export function getManagerCardLift(dark) {
  return dark ? "0 20px 42px rgba(0,0,0,.34)" : "0 16px 36px rgba(15,23,42,.10)";
}

export function getTypeCatalogShadow(dark) {
  return dark ? "0 8px 24px rgba(0,0,0,.2)" : "0 8px 24px rgba(15,23,42,.06)";
}

export function getAccountsCardLift(dark) {
  return dark
    ? "0 0 0 1px rgba(255,255,255,0.05), 0 10px 36px rgba(0,0,0,0.4)"
    : "0 1px 2px rgba(0,0,0,0.04), 0 12px 36px rgba(0,0,0,0.08)";
}
